export default "__VITE_ASSET__uSLB_osn__"